export const goldAccess = {
  title: "Welcome back!<1/>You are already a Gold Member!",
  startReading: "Start reading",
  continueReading: "Continue reading",
  continueToPurchase: "Continue to purchase book",
};
